import { useState, useRef } from "react";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { API } from "./helpers";

export function ScanDialog({ open, onClose, onScanned }) {
  const [scanning, setScanning] = useState(false);
  const fileRef = useRef(null);

  const handleFile = async (file) => {
    if (!file) return;
    setScanning(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const token = localStorage.getItem("token");
      const res = await fetch(`${API}/crm/scan-business-card`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      if (res.ok) {
        const data = await res.json();
        toast.success("Visitenkarte erkannt!");
        onScanned(data);
        onClose();
      } else {
        const err = await res.json();
        toast.error(err.detail || "Scan fehlgeschlagen");
      }
    } catch {
      toast.error("Fehler beim Scannen");
    } finally {
      setScanning(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle>Visitenkarte scannen</DialogTitle></DialogHeader>
        <p className="text-[12px] text-gray-500 py-1">
          Fotografieren oder laden Sie eine Visitenkarte hoch. Die Kontaktdaten werden automatisch erkannt.
        </p>
        <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => handleFile(e.target.files?.[0])} />
        {scanning ? (
          <div className="flex flex-col items-center py-6">
            <Loader2 className="w-6 h-6 animate-spin text-gray-500 mb-2" />
            <p className="text-[12px] text-gray-500">Wird analysiert...</p>
          </div>
        ) : (
          <Button className="w-full h-10" onClick={() => fileRef.current?.click()} data-testid="scan-upload-btn">
            <Camera className="w-4 h-4 mr-2" /> Foto aufnehmen / hochladen
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
}
